import { ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export abstract class RowPopupComponent {
  data: any;
  config: any;
  constructor(
    public activeModal: NgbActiveModal,
    public changeRef: ChangeDetectorRef) {
  }

  public close() {
    this.activeModal.close(true);
  }

  public cancel() {
    this.activeModal.close(false);
  }

  public dismiss() {
    this.activeModal.dismiss('Cross click');
  }
}
